import type { FilterSpec } from "../components/filters/specs.ts";

/** The dashboards' period pill: the last 7, 30 or 90 days, or all time. */
export const PERIODS: { value: string; label: string; days: number | null }[] = [
  { value: "7d", label: "7 days", days: 7 },
  { value: "30d", label: "30 days", days: 30 },
  { value: "90d", label: "90 days", days: 90 },
  { value: "all", label: "All time", days: null },
];
export const DEFAULT_PERIOD = "30d";
// "All time" is the period pill's "nothing picked" (`period=all`).
export const PERIOD_OPTIONS = PERIODS.filter((p) => p.days !== null).map((p) => ({ value: p.value, label: p.label }));

/** The URL's `period`, or the default when it is missing or unknown. */
export function periodFrom(value: string | null): string {
  return PERIODS.some((p) => p.value === value) ? value! : DEFAULT_PERIOD;
}

/** Local midnight `days` ago, as the API's `since`; undefined for all time. */
export function sinceFor(period: string): string | undefined {
  const days = PERIODS.find((p) => p.value === period)?.days ?? null;
  if (days === null) return undefined;
  const d = new Date();
  d.setDate(d.getDate() - days);
  d.setHours(0, 0, 0, 0);
  return d.toISOString();
}

export function periodLabel(period: string): string {
  return PERIODS.find((p) => p.value === period)?.label ?? "";
}

/** The period pill's filter spec (URL `period`). */
export function periodSpec({ pinned = true }: { pinned?: boolean } = {}): FilterSpec {
  return {
    kind: "options",
    key: "period",
    label: "Period",
    param: "period",
    multiple: false,
    pinned,
    default: [DEFAULT_PERIOD],
    noneValue: "all",
    noneLabel: "All time",
    options: PERIOD_OPTIONS,
  };
}
